import { Box, Drawer, IconButton, Typography } from '@mui/material';

import PreviewDrawer from '../../components/shared/PreviewDrawer';

import { CloseIcon, PillIcon } from '../../components/shared/CustomIcons';

import { IMedicationDetails } from '../../constants/types';

const MedicationDetails: React.FC<IMedicationDetails> = ({
  isPreviewModalOpen,
  selectedMedication,
  setIsPreviewModalOpen,
}) => {
  return (
    <Drawer
      PaperProps={{
        sx: {
          minHeight: 640,
          width: {
            sm: 390,
          },
          m: '0 auto',
          boxShadow: 1,
          borderRadius: '24px 24px 0 0',
        },
      }}
      open={isPreviewModalOpen}
      anchor="bottom"
    >
      <Box sx={{ p: 3 }} className="d-flex flex-column flex-1">
        <Box sx={{ gap: 2, mb: 3 }} className="d-flex">
          <IconButton
            aria-label="close"
            sx={{ color: 'text.primary', p: 0, ml: 'auto' }}
            onClick={() => setIsPreviewModalOpen(!isPreviewModalOpen)}
          >
            <CloseIcon sx={{ fontSize: 40 }} />
          </IconButton>
        </Box>
        <Box
          sx={{ gap: 4, mb: 8 }}
          className="d-flex flex-column align-items-center"
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              bgcolor: 'paleBlue.main',
              color: 'tertiary.main',
              p: 1.5,
              borderRadius: 6.75,
            }}
            className="d-flex justify-content-center align-items-center"
          >
            <PillIcon sx={{ fontSize: 53 }} />
          </Box>
          <Typography variant="h5" sx={{ color: 'tertiary.main' }}>
            Your medication details
          </Typography>
        </Box>
        <PreviewDrawer values={selectedMedication} />
      </Box>
    </Drawer>
  );
};

export default MedicationDetails;
